import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";

function SearchGridPager(dataView, grid, $container, grid_model, grid_state_model, bindingContext, viewModel) {
        var $status;
        function init() {
                dataView.onPagingInfoChanged.subscribe(function (e, pagingInfo) {
                        updatePager(pagingInfo);
                });
                constructPagerUI();
                updatePager(dataView.getPagingInfo());
        }

        function getNavState() {
                var cannotLeaveEditMode = !Slick.GlobalEditorLock.commitCurrentEdit();
                var pagingInfo = dataView.getPagingInfo();
                var lastPage = pagingInfo.totalPages - 1;

                return {
                        canGotoFirst: !cannotLeaveEditMode && pagingInfo.pageSize != 0 && pagingInfo.pageNum > 0,
                        canGotoLast: !cannotLeaveEditMode && pagingInfo.pageSize != 0 && pagingInfo.pageNum != lastPage,
                        canGotoPrev: !cannotLeaveEditMode && pagingInfo.pageSize != 0 && pagingInfo.pageNum > 0,
                        canGotoNext: !cannotLeaveEditMode && pagingInfo.pageSize != 0 && pagingInfo.pageNum < lastPage,
                        pagingInfo: pagingInfo
                }
        }

        function setPageSize(n) {
                dataView.setRefreshHints({
                        isFilterUnchanged: true
                });
                dataView.setPagingOptions({pageSize: n});
        }

        function gotoFirst() {
                if (getNavState().canGotoFirst) {
                        dataView.setPagingOptions({pageNum: 0});
                }
        }

        function gotoLast() {
                var state = getNavState();
                if (state.canGotoLast) {
                        dataView.setPagingOptions({pageNum: state.pagingInfo.totalPages - 1});
                }
        }

        function gotoPrev() {
                var state = getNavState();
                if (state.canGotoPrev) {
                        dataView.setPagingOptions({pageNum: state.pagingInfo.pageNum - 1});
                }
        }

        function gotoNext() {
                var state = getNavState();
                if (state.canGotoNext) {
                        dataView.setPagingOptions({pageNum: state.pagingInfo.pageNum + 1});
                }
        }

        function constructPagerUI() {
                var $nav_container = $container.children(".navbar").empty();
                var $nav = $("<span class='slick-pager-nav' ></span>").appendTo($nav_container);
                var $settings = $("<span class='slick-pager-settings' ></span>").appendTo($nav_container);
                $status = $("<span class='slick-pager-status' ></span>").appendTo($nav_container);
                $settings.append("<span class='slick-pager-settings-expanded' style='display:none'>Show: <a data=0>All</a><a data='-1'>Auto</a><a data=25>25</a><a data=50>50</a><a data=100>100</a></span>");
                
                $settings.find("a[data]").click(function (e) {
                        var pagesize = $(e.target).attr("data");
                        if (pagesize != undefined) {
                                if (pagesize == -1) {
                                        var vp = grid.getViewport();
                                        setPageSize(vp.bottom - vp.top);
                                } else {
                                        setPageSize(parseInt(pagesize));
                                }
                        }
                });
                var icon_prefix = "<span class='ui-state-default ui-corner-all ui-icon-container'><span class='ui-icon ";
                var icon_suffix = "' ></span></span>";
                //$(icon_prefix + "ui-icon-document" + icon_suffix)
            $("<button class='small'>{0}</button>".format(_("grid_pager_constructpagerui_searchgridpager_export", "Export"))).button({ "icons":{"primary":"ui-icon-document"}, "text":false, "title":_("grid_pager_title_export_to_csv", "Export to CSV") })
                        .click(function(ev,ui) {
                            ev.preventDefault();
                                if (typeof dataView.getPostData == "function") {
                                        var postdata = dataView.getPostData();
                                        var columns = grid.getColumns();
                                        var cols = []
                                        $.each(columns, function(k,v) {
                                                console.log("got column: ", this);
                                                if (this.name && !(this.name == "#"))
                                                        cols.push(this.name);
                                        });
                                        cols.push("id");
                                        postdata.postdata.__columns = "["+cols.join(",")+"]";
                                        var urlencoded = $.param(postdata.postdata);
                                        var url = postdata.url+"/export?"+urlencoded;//Crimson.root+"bsearch/"+ (model.entity||"") + "/export?"+urlencoded;
                                        window.open(url);
                                }
                                else
                                {
                                }
                        })
                        .appendTo($nav);
            $("<button class='small'>{0}</button>".format(_("grid_pager_constructpagerui_searchgridpager_refresh", "Refresh"))).button({ "icons":{"primary":"ui-icon-arrowrefresh-1-w"}, "text":false, "title":_("grid_pager_title_refresh", "Refresh") })
                        .click(function(ev,ui) {
                            ev.preventDefault();
                            if (typeof dataView.refresh == "function") {
                                dataView.refresh();
                            }
                        })
                        .appendTo($nav);
                        
                        
                        
                var $action_panel = $container.children(".actions");
                var subcontext = bindingContext.createChildContext(viewModel);
                ko.utils.extend(subcontext, {"grid_state_model":grid_state_model, "grid_model":grid_model });
                $action_panel[0] && ko.applyBindingsToDescendants(subcontext, $action_panel[0]);

                /*
                  $(icon_prefix + "ui-icon-lightbulb" + icon_suffix)
                  .click(function () {
                  $(".slick-pager-settings-expanded").toggle()
                  })
                  .appendTo($settings);

                  $(icon_prefix + "ui-icon-seek-first" + icon_suffix)
                  .click(gotoFirst)
                  .appendTo($nav);

                  $(icon_prefix + "ui-icon-seek-prev" + icon_suffix)
                  .click(gotoPrev)
                  .appendTo($nav);

                  $(icon_prefix + "ui-icon-seek-next" + icon_suffix)
                  .click(gotoNext)
                  .appendTo($nav);

                  $(icon_prefix + "ui-icon-seek-end" + icon_suffix)
                  .click(gotoLast)
                  .appendTo($nav);

                  $container.find(".ui-icon-container")
                  .hover(function () {
                  $(this).toggleClass("ui-state-hover");
                  });
                */
                $container.children().wrapAll("<div class='slick-pager clearfix' ></div>");
        }


        function updatePager(pagingInfo) {
                var state = getNavState();

                $container.find(".slick-pager-nav span").removeClass("ui-state-disabled");
                if (!state.canGotoFirst) {
                        $container.find(".ui-icon-seek-first").addClass("ui-state-disabled");
                }
                if (!state.canGotoLast) {
                        $container.find(".ui-icon-seek-end").addClass("ui-state-disabled");
                }
                if (!state.canGotoNext) {
                        $container.find(".ui-icon-seek-next").addClass("ui-state-disabled");
                }
                if (!state.canGotoPrev) {
                        $container.find(".ui-icon-seek-prev").addClass("ui-state-disabled");
                }

                if (pagingInfo.totalRows == 0) 
                        $status.text("no data");
                else if (pagingInfo.totalRows == 1)
                        $status.text(_("grid_pager_updatepager_searchgridpager_row", "1 row"));
            else $status.text(_("grid_pager_updatepager_searchgridpager_rows", "{0} rows").format(pagingInfo.totalRows));
        }

        init();
}

// Slick.Controls.Pager
$.extend(true, window, { Slick:{ Controls:{ SearchPager:SearchGridPager }}});
